import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/IconButton';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as navigationHelper from '../../../helpers/navigationHelper';
import * as colourHelper from '../../../helpers/colourHelper';
import _ from 'lodash';

class TitleScreenCircularOverlay extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            show_project_title: appHelper.isDefined(this.props.screen.show_project_title) ? this.props.screen.show_project_title : true,
            locale: {},
            renderedObjects: [],
            assets: {
                background: {
                    src: "",

                },
                image: {
                    src: "",
                },
                character: {
                    src: "",
                },
                character_position: "close_up",
                icons: []
            },
            isDisabled: false,
            start_label: appHelper.getLocaleString("start_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            //new colours
            colours: {
                button_colour: colourHelper.getColourValue(this.props.screen.button_colour),
                button_text_colour: colourHelper.getColourValue(this.props.screen.button_text_colour),
                icon_fill_colour: colourHelper.getColourValue(this.props.screen.icon_fill_colour),
                overlay_colour_1: colourHelper.getColourValue(this.props.screen.overlay_colour_1),
                overlay_colour_2: colourHelper.getColourValue(this.props.screen.overlay_colour_2),
                text_colour: colourHelper.getColourValue(this.props.screen.text_colour),
            },
            maxIcons: 5,
        };
        this.getLocale = this.getLocale.bind(this);
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getButtonLabel = this.getButtonLabel.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
    }

    componentDidMount() {
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(false);
        this.getLocale();
        this.getAssets();
        setTimeout(function () {
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }.bind(this), 1000);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                start_label: appHelper.getLocaleString("start_label"),
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    setScreenAccessed() {
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.props.actions.setScreenTitle(locale.title);
        this.setState({locale: Object.assign({}, locale)});
    }


    getAssets() {
        let background = {};
        let icons = [];
        let screenCharacter = {};
        let characterAsset = {};

        let image = {};
        if (appHelper.isDefined(this.state.screen.assets.background)) {
            background = appHelper.getBackgroundAsset(this.state.screen.assets.background);

        }

        if (appHelper.isDefined(this.state.screen.assets.image)) {
            if (this.state.screen.assets.image.constant === assetConstants.ASSET_TYPE_ICON) {
                image = appHelper.getIconAsset(this.state.screen.assets.icon);
            } else if (this.state.screen.assets.image.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
                image = appHelper.getLibraryImageAsset(this.state.screen.assets.image);
            }

        }

        if (appHelper.isDefined(this.state.screen.assets.character)) {
            screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.character);
        }

        let maxIcons = this.state.maxIcons;
        if (appHelper.isDefined(this.state.screen.assets.icons) && this.state.screen.assets.icons.length > 0) {
            _.forEach(this.state.screen.assets.icons, function (iconAsset) {
                let icon = appHelper.getIconAsset(iconAsset);
                if (icons.length < maxIcons) {
                    icons = dataHelper.immutablePush(icons, icon);
                }
            });
        }


        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
                image: appHelper.isDefined(image.src) ? image : this.state.assets.image,
                character: appHelper.isDefined(this.state.screen.assets.character) ? characterAsset : this.state.assets.character,
                character_position: appHelper.isDefined(this.state.screen.assets.character) && appHelper.isDefined(screenCharacter.position) ? screenCharacter.position : "close_up",
                icons: icons
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        return this.props.biteCallbacks.getBiteId();
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status
        };

        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                    let next_lesson_location = navigationHelper.getNextLessonLocation(this.getScreenId());
                    this.props.actions.setNextButtonState(true, next_lesson_location);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    onProgressionClicked() {
        this.setState({isDisabled: true});
        this.navigateToNextScreen();
    }

    navigateToNextScreen() {
        let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
        if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
            this.context.router.push('menu');
        } else {
            this.props.actions.setNextLessonLocation(this.getScreenId());
        }
    }

    setClass() {
        return this.state.screen.include_logo ? "logo" : "";
    }

    getButtonLabel() {
        let bite = appHelper.getBiteById(this.getBiteId());
        let biteIndex = appHelper.getArrayObjectIndexByKey(this.props.userData.bites, "bite_id", bite.bite_id);
        let screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", this.state.screen.screen_id);
        if (appHelper.isDefined(this.state.locale.button_label)) {
            return this.state.locale.button_label;
        } else {
            if (biteIndex == 0 && screenIndex == 0) {
                return this.state.start_label;
            } else {
                return this.state.continue_label;
            }
        }
    }

    render() {

        return (
            appHelper.isDefined(this.state.assets.background.src) && this.state.assets.background.src.length > 0
                ?
                <div className="customer-scenario">
                    <div className="background-container">
                        <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                    </div>
                    <div className="screen-container">
                        <div className={`circular-overlay-screen`}>
                            <div className="title-content">

                                <div className={`title-page-content`}>
                                    {this.state.assets.image.src.length > 0
                                        ? <div className="title-icon-container">
                                            <img src={this.getImagePath(this.state.assets.image.src)} alt=""/>
                                        </div>
                                        : null
                                    }
                                    <div className="title-container">
                                        {
                                            appHelper.isDefined(this.state.locale.series_title)
                                                ?
                                                <h1 dangerouslySetInnerHTML={{__html: this.state.locale.series_title}}
                                                    style={{color: this.state.colours.text_colour}}/>
                                                :
                                                null
                                        }
                                        {
                                            appHelper.isDefined(this.state.locale.title) && this.state.locale.title !== null && this.state.locale.title.length > 0
                                                ?
                                                <h2 dangerouslySetInnerHTML={{__html: this.state.locale.title}}
                                                    style={{color: this.state.colours.text_colour}}/>
                                                :
                                                null
                                        }
                                        {
                                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                                ?
                                                <div className="instruction-container">
                                                    <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}
                                                         style={{color: this.state.colours.text_colour}}/>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                </div>

                                <div className="content-spacer">
                                    <div className="ms-button-container ms-only">

                                        <div>
                                            <br/><br/>
                                            <input
                                                className={`btn btn-lg title-screen-btn ${this.state.screen.button_shape}`}
                                                style={{
                                                    background: this.state.colours.button_colour,
                                                    color: this.state.colours.button_text_colour
                                                }}
                                                type="button" disabled={this.state.isDisabled}
                                                value={this.getButtonLabel()}
                                                onClick={this.onProgressionClicked}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="title-page-nav-bar"
                                     style={{background: this.state.colours.overlay_colour_2}}>
                                    <div className="title-page-icons">
                                        <div className="title-screen-icon-list no-ms">
                                            {this.state.assets.icons.length > 0
                                                ?

                                                this.state.assets.icons.map(icon =>
                                                    <div key={icon.id} className="title-screen-icon-item ms-only">
                                                        <div
                                                            className={`title-screen-icon-container ${this.state.screen.icon_fill}`}
                                                            style={{background: this.state.screen.icon_fill !== "none" ? this.state.colours.icon_fill_colour : "transparent"}}>
                                                            <img src={this.getImagePath(icon.src)} alt=""/>
                                                        </div>
                                                    </div>
                                                )

                                                :
                                                null
                                            }
                                            <div className="title-screen-icon-item no-ms">
                                                <input
                                                    className={`btn btn-lg title-screen-btn ${this.state.screen.button_shape}`}
                                                    style={{
                                                        background: this.state.colours.button_colour,
                                                        color: this.state.colours.button_text_colour
                                                    }}
                                                    type="button" disabled={this.state.isDisabled}
                                                    value={this.getButtonLabel()}
                                                    onClick={this.onProgressionClicked}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="color-overlay-container">
                                <div className="circle-shape" style={{background: this.state.colours.overlay_colour_1}}>
                                    <div className="circle-icon-wrapper">
                                        {this.state.assets.icons.map(icon =>
                                            <div key={icon.id} className="title-screen-icon-item">
                                                <div
                                                    className={`title-screen-icon-container ${this.state.screen.icon_fill}`}
                                                    style={{background: this.state.screen.icon_fill !== "none" ? this.state.colours.icon_fill_colour : "transparent"}}>
                                                    <img src={this.getImagePath(icon.src)} alt=""/>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="sub-circle-shape" style={
                                        typeof this.props.screen.overlay_colour_1 === "string"
                                            ?
                                                {
                                                    background: colourHelper.getColourShade(this.state.colours.overlay_colour_1, 0.2),
                                                    borderColor: colourHelper.getColourShade(this.state.colours.overlay_colour_1, 0.7)
                                                }
                                            :
                                            {
                                                background: "transparent" ,
                                                borderColor: "transparent"
                                            }
                                    }/>
                                </div>

                                {
                                    this.state.assets.character.src.length > 0
                                        ?
                                        <div className={`title-page-character ${this.state.assets.character_position}`}>
                                            <div className={`screen-character`}>
                                                <img src={this.getImagePath(this.state.assets.character.src)} alt=""/>
                                            </div>
                                        </div>
                                        :
                                        null
                                }
                            </div>

                        </div>
                    </div>
                </div>
                : null
        );
    }
}

TitleScreenCircularOverlay.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
};

TitleScreenCircularOverlay.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        titles: state.titles,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TitleScreenCircularOverlay);



/** WEBPACK FOOTER **
 ** ./src/components/screens/titleScreen/TitleScreenCircularOverlay.js
 **/